import(/* webpackMode: "eager" */ "C:\\Users\\reser\\Workspaces\\Podar\\apps\\web\\app\\globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "C:\\Users\\reser\\Workspaces\\Podar\\apps\\web\\components\\AuthProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\reser\\Workspaces\\Podar\\apps\\web\\components\\UserMenu.tsx");
